import { ProgressStepper } from "components/ShipmentProgressSteps/progressStepper";

const QUOTES_ONLY_SHIPMENT_PROGRESS_STEPS = ["POSTED", "NOTIFIED", "QUOTES"];

interface Props {
  shipment: ShipperCondensedShipment | undefined;
  progress: ShipmentProgress | null;
}

// QUOTES_ONLY shipments cannot be booked, so the stepper ends at QUOTES rather
// than continuing through the post-booking steps.
export function QuotesOnlyShipmentProgressStepper(props: Props) {
  const { shipment, progress } = props;

  const getProgress = () => {
    if (!shipment || !progress) {
      return 0;
    }
    if (progress.quote_count > 0) {
      return 2;
    }
    return 1;
  };

  return (
    <ProgressStepper
      allSteps={QUOTES_ONLY_SHIPMENT_PROGRESS_STEPS}
      progressValue={getProgress()}
      shipmentStatus={shipment?.shipment_status}
    />
  );
}
